import React from 'react';
import { useLocation } from 'react-router-dom';
import HelpPanel from '@cloudscape-design/components/help-panel';
import Icon from '@cloudscape-design/components/icon';
import Link from '@cloudscape-design/components/link';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';

const AppHelpPanel = () => {
  const location = useLocation();
  const path = location.pathname;

  const getHelpContent = () => {
    if (path.includes('/indicator-submission')) {
      return {
        title: 'Help Panel',
        description: 'Submision details',
        submissionSteps: [
          'Review the Expectations section to understand the submission requirements ',
          'Enter detailed input in Indicator Text Evidence',
          'Upload supporting documentation using the Choose files button',
          'Set Judgment',
          'Review the AI readiness score and findings',
          'Save or submit using the appropriate action button'
        ],
        buttonGuide: [
          {
            name: 'Cancel',
            description: 'Exits the form without saving changes'
          },
          {
            name: 'Save & GenAI Review',
            description: 'Saves your work and generates an AI analysis of your submission'
          },
          {
            name: 'Save',
            description: 'Saves your current progress without AI review'
          }
        ],
        tips: [
          'Please consider the naming, format and type of the supporting evidence.',
          'Review AI feedback to improve your submission quality',
          'Save your work regularly to prevent data loss'
        ],
        resources: [
          {
            title: 'Submission Guidelines',
            href: '#'
          },
          {
            title: 'Required Templates',
            href: '#'
          },
          {
            title: 'AI Review Guide',
            href: '#'
          }
        ]
      };
    }
    
    // Default content for other pages
    return {
      title: 'Help and Resources',
      description: 'Welcome to the application portal.',
      submissionSteps: [
        'Navigate through different sections using the menu',
        'Access your applications and submissions',
        'Track progress and status updates'
      ],
      tips: [
        'Use the navigation menu on the left to move between sections',
      ],
      resources: [
        {
          title: 'User Guide',
          href: '#'
        },
        {
          title: 'FAQ',
          href: '#'
        }
      ]
    };
  };

  const content = getHelpContent();

  return (
    <HelpPanel
      header={<h2>{content.title}</h2>}
      // footer={
        // <div>
        //   <h3>Still need help?</h3>
        //   <SpaceBetween size="s">
        //     <Link href="#" external>Contact support</Link>
        //     <Link href="#" external>Schedule a consultation</Link>
        //   </SpaceBetween>
        // </div>
      // }
    >
      <SpaceBetween size="l">
        <Box variant="p">
          {content.description}
        </Box>
        
        <div>
          <h3>Submission Steps</h3>
          <ul>
            {content.submissionSteps.map((step, index) => (
              <li key={index} style={{ marginBottom: '8px' }}>
                <Icon name="status-pending" /> {step}
              </li>
            ))}
          </ul>
        </div>

        {content.buttonGuide && (
          <div>
            <h3>Available Actions</h3>
            <SpaceBetween size="s">
              {content.buttonGuide.map((button, index) => (
                <Box key={index} variant="p">
                  <strong><Icon name="status-info" /> {button.name}:</strong> {button.description}
                </Box>
              ))}
            </SpaceBetween>
          </div>
        )}

        <div>
          <h3>Quick Tips</h3>
          <SpaceBetween size="s">
            {content.tips.map((tip, index) => (
              <Box key={index} variant="p">
                <Icon name="status-positive" /> {tip}
              </Box>
            ))}
          </SpaceBetween>
        </div>

        {/* <div>
          <h3>Related Resources</h3>
          <SpaceBetween size="s">
            {content.resources.map((resource, index) => (
              <Link key={index} href={resource.href} external>
                {resource.title}
              </Link>
            ))}
          </SpaceBetween>
        </div> */}
      </SpaceBetween>
    </HelpPanel>
  );
};

export default AppHelpPanel;